<template>
    <div class="text-over-tooltip-components">
        <hc-tooltip :effect="effect" :disabled="isDisabledTooltip" :content="content" :placement="placement" popper-class="text-over-tooltip">
            <div class="ellipsis" :class="className" @mouseover="onMouseOver(refName)">
                <span :ref="refName">{{ content }}</span>
            </div>
        </hc-tooltip>
    </div>
</template>

<script>
export default {
    name: 'TextOverTooltip',
    props: {
        // 显示的文字内容
        content: String,
        // 设置父元素的样式：比如宽度字体等，需可以自己在组件内部配置样式比如字体大小20：fs20
        className: String,
        // 子元素标识（如在同一页面中调用多次组件，此参数不可重复）
        refName: String,
        // 默认提供的主题 dark/light
        effect: {
            type: String,
            default: 'dark',
        },
        // Tooltip 的出现位置top/top-start/top-end/bottom/bottom-start/bottom-end/left/left-start/left-end/right/right-start/right-end
        placement: {
            type: String,
            default: 'top',
        },
    },
    data() {
        return {
            isDisabledTooltip: true, // 是否需要禁止提示
        }
    },
    methods: {
        // 移入事件: 判断内容的宽度contentWidth是否大于父级的宽度
        onMouseOver(str) {
            const parentWidth = this.$refs[str].parentNode.offsetWidth
            const contentWidth = this.$refs[str].offsetWidth
            // 判断是否禁用tooltip功能
            this.isDisabledTooltip = contentWidth <= parentWidth

            // 显示两行的场景进行处理
            if (this.className && this.className === 'ellipsis_multiple') {
                const TemporaryTag = document.createElement('span')
                TemporaryTag.innerText = this.content
                TemporaryTag.className = 'getTextWidth'
                TemporaryTag.style = 'font-size:14px'

                document.querySelector('body').appendChild(TemporaryTag)
                const currentWidth = document.querySelector('.getTextWidth').offsetWidth
                document.querySelector('.getTextWidth').remove()
                this.isDisabledTooltip = currentWidth <= (parentWidth * 2) - 8
            }
        },
    },
}
</script>
<style lang="less">
.text-over-tooltip.hc-tooltip__popper.is-dark{
  word-break: break-all;
}
</style>

<style lang="less" scoped>

.text-over-tooltip-components {
  display: flex;
  /* 文字超出宽度显示省略号 单行 */
  .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }

  /* 文字超出宽度显示省略号 2行 */
  .ellipsis_multiple {
      white-space: break-spaces;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
  }
}
</style>
